<template>
    <v-container class="h-100 dictionary-page">
        <v-card class="card-container">
            <v-card-title>
                <v-row>
                    <v-col cols="auto">
                        <v-btn
                                dense
                                color="var(--color-blue)"
                                @click="showAddModal"
                                dark
                        >
                            <span class="btn-text"><v-icon dark>add</v-icon> Добавить филиал</span>
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-text-field
                                class="search-block"
                                v-model="search"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                solo
                                placeholder="Поиск"
                                dense
                                hide-details
                        />
                    </v-col>
                    <v-col cols="auto">
                        <span class="filter-row-label">Специализация:</span>
                    </v-col>
                    <v-col cols="2">
                        <v-select
                                v-model="selectedTypes"
                                multiple
                                item-text="partnerTypeName"
                                item-value="id"
                                solo
                                dense
                                hide-details
                                :items="partnerTypes"
                        >
                            <template v-slot:prepend-item>
                                <v-list-item
                                        ripple
                                        @click="toogleAllTypes"
                                >
                                    <v-list-item-action>
                                        <v-icon :color="selectedTypes.length > 0 ? 'indigo darken-4' : ''">
                                            {{ icon }}
                                        </v-icon>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            Выбрать все
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider class="mt-2"></v-divider>
                            </template>
                            <template v-slot:selection="{ item, index }">
                                <div v-if="likesAllTypes">
                                    <span v-if="index === 0">Все</span>
                                </div>
                                <div v-else>
                                    <span v-if="index === 0">{{ item.partnerTypeName }}</span>
                                    <span
                                            v-if="index === 1"
                                            class="grey--text caption"
                                    >
                                        (+{{ selectedTypes.length - 1 }})
                                    </span>
                                </div>

                            </template>
                        </v-select>
                    </v-col>
                    <v-spacer></v-spacer>
                </v-row>

            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="h-100 p-0" style="overflow-y: scroll">
                <v-data-table
                        :loading="loading"
                        no-data-text="Нет элементов"
                        no-results-text="Не найдено элементов"
                        loading-text="Загрузка данных"
                        calculate-widths
                        :items-per-page="filteredItems.length"
                        :items="filteredItems"
                        :headers="fields"
                        :search="search"
                        height="100%"
                        hide-default-footer
                        class="elevation-1 h-100"
                >
                    <template v-slot:item.phone="{item}">
                        <span v-for="phone in item.phones">{{ phone.phoneNumber }}<br></span>
                    </template>

                    <template v-slot:item.partnerTypes="{item}">
                        <template v-for="(type, ind) in item.partnerTypes">
                            <span>{{ type.partnerType }}</span><span
                                v-if="item.partnerTypes.length>0&&ind<item.partnerTypes.length-1"> • </span>
                        </template>
                    </template>

                    <template v-slot:item.edit="{item}">
                        <v-btn icon @click="showEditModal(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <addBranchModal :show="showModalAdd" @close="showModalAdd=false"></addBranchModal>
        <editBranchModal :item="selected" :show="showModalEdit" @close="showModalEdit=false"></editBranchModal>
    </v-container>

</template>

<script>

    import editBranchModal from '../../components/dictionaries/PartnerBranches/EditBranchModal.vue'
    import addBranchModal from '../../components/dictionaries/PartnerBranches/AddNewBranchModal.vue'

    export default {
        name: "OrgBranches",
        components: {addBranchModal, editBranchModal},
        data() {
            return {
                showModalAdd: false,
                showModalEdit: false,
                selectedTypes: [],
                selected: null,
                loading:false,
                search: '',
                fields: [
                    {value: "address", text: "Адрес"},
                    {value: "city", text: "Город", width:150},
                    {value: "organization", text: "Организация", sortable: true},
                    {value: "phone", text: "Телефон", width:150},
                    {value: "partnerTypes", text: "Тип"},
                    {value: "edit", text: "", width:50},
                ],

            }
        },
        created() {
            const vm=this;
            this.loading=true
            this.$store.dispatch("OrgBranches/loadGeoItems").then(x=>vm.loading=false).catch((err) => {
                console.log(err)
                this.loading=false;
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки списка партнеров!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });

            if (this.$store.state.PartnerTypes.items.length == 0) {
                this.$store.dispatch("PartnerTypes/loadPartnerTypes").then(()=> {
                    vm.selectedTypes = []
                    vm.$store.state.PartnerTypes.items.forEach(item => {
                        vm.selectedTypes.push(item.id)
                    })
                }).catch((err) => {
                    console.log(err)
                    this.$bvToast.toast(err.message, {
                        title: `Ошибка загрузки списка типов партнеров!`,
                        variant: "danger",
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 3000,
                        solid: true
                    })
                });
            }
        },

        computed: {
            filteredItems() {
                var items = this.$store.state.OrgBranches.orgGeoItems;
                if (items != null) {
                    return items.filter((elem) => {
                        if(this.selectedTypes.length>0){
                            let intersection= elem.partnerTypes.filter(x=>this.selectedTypes.includes(x.partnerTypeId))
                            if(intersection.length>0){
                                return true
                            }
                            else return false
                        }
                        else return false
                    }).sort((a, b) => {
                        var nameA = a.organization.toLowerCase(), nameB = b.organization.toLowerCase()
                        if (nameA < nameB) //сортируем строки по возрастанию
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    });
                }
                else return [];
            },
            partnerTypes() {
                var res = [];
                var pTypes = this.$store.state.PartnerTypes.items;
                if (pTypes != null && pTypes != undefined) {
                    return pTypes
                }
                return res;
            },

            icon () {
                if (this.likesAllTypes) return 'mdi-close-box'
                if (this.likesSomeTypes) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            },

            likesSomeTypes () {
                return this.selectedTypes.length > 0 && !this.likesAllTypes
            },

            likesAllTypes() {
                return this.selectedTypes.length === this.partnerTypes.length
            },
        },

        methods: {
            toogleAllTypes() {
                this.$nextTick(() => {
                    if (this.likesAllTypes) {
                        this.selectedTypes = []
                    }
                    else {
                        this.selectedTypes = []
                        this.partnerTypes.forEach(item => {
                            this.selectedTypes.push(item.id)
                        })
                    }
                })
            },

            showAddModal() {
                this.showModalAdd = true
            },
            showEditModal(item) {
                this.selected = item
                this.showModalEdit = true
            },

            rowSelected(row) {
                this.selected = row[0]
            },

            setLocation(location) {
                if (location != null) {
                    this.editOrgGeoInfoItem.latitude = location.lat;
                    this.editOrgGeoInfoItem.longitude = location.lng;
                }
            },

            citySelect(value) {
                var curCity = this.cities.find(x => x.id == value);
                if (curCity != null) {
                    this.editOrgGeoInfoItem.latitude = curCity.latitude;
                    this.editOrgGeoInfoItem.longitude = curCity.longitude;
                    this.$root.$emit("locationChanged", {lat: curCity.latitude, lng: curCity.longitude})
                }
            }
        },


    }
</script>

<style scoped>

    .filter-row-label{
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color:var(--color-2);
    }
</style>
